import { LOCATION_STATES } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'

const FilterButton = () => {
  const { t } = useTranslation('filters')
  const { push } = useHistory()
  return (
    <div
      className='filter__button center'
      onClick={() => {
        push(window.location.pathname, LOCATION_STATES.popup('filters'))
      }}>
      <i className='icon icon--filter' />
      <span>{t('filter')}</span>
    </div>
  )
}

export default FilterButton